import logout from '../assets/images/001-logout.png';
import admin from '../assets/images/010-admin.png';
import reports from '../assets/images/003-report.png';
import students from '../assets/images/002-students.png';
import lessons from '../assets/images/009-schedule.png';

const routes = {
  profile: {
    label: "יציאה",
    icon: logout,
    path: "logout",
    displayIndex: 10
  },
  admin: {
    label: "ניהול",
    icon: admin,
    path: "management",
    displayIndex: 1
  },
  manager: {
    label: "דוחות",
    icon: reports,
    path: "reports",
    displayIndex: 2
  },
  lessons: {
    label: "שיעורים",
    icon: lessons,
    path: "lessons",
    displayIndex: 3
  },
  students: {
    label: "תלמידים",
    icon: students,
    path: "students",
    displayIndex: 4
  }
};

export default routes;